import { Component, EventEmitter, OnInit, Input, Output } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import {
  EventCustomerValidationStatus,
  EventCustomerValidationType,
  EventType,
  ProgramTypesGUID
} from '../../../../models/_enum-collections';
import { CustomerValidationInfo } from '../../../../models/customer-validation-info.model';
import { CustomerValidationPreviewEventDetails } from '../../../../models/customer-validation-preview-event-details.model';
import { CustomerPreviewInput } from '../../../../models/customer-validation-preview-input.model';
import { EventCustomerRejectionReason } from '../../../../models/event-customer-rejection-reason.model';
import { EventCustomerValidationInfoRequestModel } from '../../../../models/event-customer-validation-request.model';
import { EventCustomers } from '../../../../models/event-customers.model';
import { PoeStatusFilter } from '../../../../models/poe-status-filter.model';
import { CommonSharedModule } from '../../../common/shared.module';
import { EventEditService } from '../../../services/event-edit.service';
import programConfigJson from '../../components/edit-event/events-config.json';

@Component({
  selector: 'app-customer-validation-preview',
  templateUrl: './customer-validation-preview.component.html',
  styleUrls: ['./customer-validation-preview.component.scss'],
  standalone: true,
  imports: [CommonSharedModule]
})
export class CustomerValidationPreviewComponent implements OnInit {
  canShowCustomerPreviewModel!: boolean;
  @Input() customerValidationPreviewInput!: CustomerPreviewInput;
  @Output() closePreviewModal = new EventEmitter<boolean>();
  @Output() reLoadList: EventEmitter<any> = new EventEmitter<any>();

  custValidationEventDetail!: CustomerValidationPreviewEventDetails;
  custValidationInfo!: CustomerValidationInfo;
  msgsUsageDetails!: any[];
  selectedPoeFilter!: PoeStatusFilter;
  poeFilterOptions!: PoeStatusFilter[];
  eventCustomerValidation: EventCustomers[] = [];
  rejectionReason!: EventCustomerRejectionReason[];
  customerValidationRejectionModalDisplay!: boolean;
  formCustomerValidationRejection!: FormGroup;
  showToolTipCustomer = false;
  firstTime!: Date;
  copiedValidationDetail = true;
  EventId!: number;
  SelectedCustomer!: EventCustomers;
  eventCustomerValidationDetail = '';
  eventIdList!: number[];
  eventIndex!: number;
  customerValidationStatus!: EventCustomerValidationInfoRequestModel;
  isApproveDeny!: boolean;
  isApproveReject!: boolean;
  eventIdTitle!: string;
  programTypeGuid!: string;
  isLoading = true;

  constructor(
    private formBuilder: FormBuilder,
    private eventEdit: EventEditService
  ) {}

  OnFormGroup() {
    this.formCustomerValidationRejection = this.formBuilder.group({
      rejectionReason: [],
      additionalNotesRejectionReason: ['']
    });
  }

  ngOnInit() {
    this.OnFormGroup();

    this.EventId = this.customerValidationPreviewInput.eventId;
    this.eventIdList = this.customerValidationPreviewInput.eventIdList || [];
    this.eventIndex = this.eventIdList.indexOf(
      this.customerValidationPreviewInput.eventId
    );
    this.showCustomerValidationPreview(this.EventId);
    this.poeFilterOptions = [
      { status: 'Pending', value: EventCustomerValidationStatus.Pending },
      { status: 'Approved', value: EventCustomerValidationStatus.Approved },
      { status: 'Rejected', value: EventCustomerValidationStatus.Rejected }
    ];
    this.selectedPoeFilter =
      this.poeFilterOptions.find(
        f => f.value == EventCustomerValidationStatus.Pending
      ) || ({} as PoeStatusFilter);
  }

  showCustomerValidationPreview(eventId) {
    this.isApproveDeny = true;
    this.canShowCustomerPreviewModel = true;
    this.isApproveReject = false;
    this.GetEventDetails(eventId);
    this.getCustomerDropDown(eventId);
    this.getRejectionReasonDropDown();
  }

  IsCustomerValidationRejected() {
    if (this.custValidationInfo !== undefined) {
      return (
        this.custValidationInfo.eventCustomerValidationStatusId ==
        EventCustomerValidationStatus.Rejected
      );
    }
    return false;
  }

  IsCustomerValidationApproved() {
    if (this.custValidationInfo !== undefined) {
      return (
        this.custValidationInfo.eventCustomerValidationStatusId ==
        EventCustomerValidationStatus.Approved
      );
    }
    return false;
  }

  GetEventDetails(eventId) {
    this.eventEdit
      .getCustomerValidationPreviewDetails(eventId)
      .subscribe(EventPreviewDetail => {
        this.isLoading = false;
        this.custValidationEventDetail = {
          dayExpiration90: EventPreviewDetail.dayExpiration90,
          eventID: EventPreviewDetail.eventID,
          partnerEmail: EventPreviewDetail.partnerEmail,
          qualifiedAmount: EventPreviewDetail.qualifiedAmount,
          partnerOrganization: EventPreviewDetail.partnerOrganization,
          registrationDate: EventPreviewDetail.registrationDate,
          workshopCompletionDate: EventPreviewDetail.workshopCompletionDate,
          workshopType: EventPreviewDetail.workshopType,
          eventTypeId: EventPreviewDetail.eventTypeId
        };

        this.getProgramTypeGuid();
        let workshopConfig = programConfigJson.program
          .find(p => p.programTypeGuid == this.programTypeGuid)
          ?.page.workshop.find(
            w => w.workshopTypeId == EventType.TeamsRoomsOneToMany
          );
        if (!workshopConfig) {
          workshopConfig = programConfigJson.program
            .find(p => p.programTypeGuid == this.programTypeGuid)
            ?.page.workshop.find(w => w.workshopTypeId == null);
        }
        this.eventIdTitle = workshopConfig?.model.EventIdTitle || '';
      });
  }

  getCustomerDropDown(eventId) {
    this.eventEdit
      .getEventCustomersDropDown(eventId)
      .subscribe(EventCustomerValidation => {
        this.eventCustomerValidation = EventCustomerValidation;

        if (this.selectedPoeFilter) {
          this.eventCustomerValidation = EventCustomerValidation.filter(
            customer =>
              customer.eventCustomerValidationStatusId ==
              this.selectedPoeFilter.value
          );
          if (!this.eventCustomerValidation.length)
            this.custValidationInfo = {} as CustomerValidationInfo;
        }
        if (this.customerValidationPreviewInput.isEditPreview) {
          this.SelectedCustomer =
            EventCustomerValidation.find(
              customer =>
                customer.customerName ===
                this.customerValidationPreviewInput.customerName
            ) || ({} as EventCustomers);
          this.getCustomerValidiationInfo(
            this.SelectedCustomer.eventCustomerId
          );
        } else {
          this.SelectedCustomer = this.eventCustomerValidation[0];
          this.getCustomerValidiationInfo(
            this.eventCustomerValidation[0].eventCustomerId
          );
        }
      });
  }

  getRejectionReasonDropDown() {
    this.eventEdit
      .getCustomerRejectionReasonsDropDown()
      .subscribe(eventCustomerRejectionReason => {
        this.rejectionReason = eventCustomerRejectionReason;
      });
  }

  closePreview() {
    this.canShowCustomerPreviewModel = false;
    if (!this.isApproveDeny) {
      this.reLoadList.emit(true);
    }
    this.closePreviewModal.emit(false);
  }

  onDenyOpen() {
    this.customerValidationRejectionModalDisplay = true;
  }

  closeDeclineModal() {
    this.customerValidationRejectionModalDisplay = false;
    this.formCustomerValidationRejection.reset();
  }

  get customerDenyButtonEnable(): boolean {
    return (
      this.formCustomerValidationRejection.controls['rejectionReason'].value !=
      null
    );
  }

  onCustomerChange(event) {
    this.getCustomerValidiationInfo(event.value.eventCustomerId);
  }

  onStatusFilterChange() {
    this.getCustomerDropDown(this.EventId);
  }

  getCustomerValidiationInfo(eventCustomerId) {
    this.eventEdit
      .getCustomerValidationInformationByCustomer(eventCustomerId)
      .subscribe(CustomerInfo => {
        this.custValidationInfo = {
          eventCustomerId: CustomerInfo.eventCustomerId,
          customerName: CustomerInfo.customerName,
          customerCountry: CustomerInfo.customerCountry,
          eventCustomerValidationTypeId:
            CustomerInfo.eventCustomerValidationTypeId,
          eventCustomerValidationType: CustomerInfo.eventCustomerValidationType,
          tenantId: CustomerInfo.tenantId,
          tpid: CustomerInfo.tpid,
          dbNumber: CustomerInfo.dbNumber,
          webUrl: CustomerInfo.webUrl,
          subscriptionId: CustomerInfo.subscriptionId,
          eventCustomerValidationStatusId:
            CustomerInfo.eventCustomerValidationStatusId
        };
        if (
          this.custValidationInfo.eventCustomerValidationTypeId ==
          EventCustomerValidationType.TenantID
        ) {
          this.eventCustomerValidationDetail = this.custValidationInfo.tenantId;
        } else if (
          this.custValidationInfo.eventCustomerValidationTypeId ==
          EventCustomerValidationType.TPID
        ) {
          this.eventCustomerValidationDetail = this.custValidationInfo.tpid;
        } else if (
          this.custValidationInfo.eventCustomerValidationTypeId ==
          EventCustomerValidationType.WebURL
        ) {
          this.eventCustomerValidationDetail = this.custValidationInfo.webUrl;
        } else if (
          this.custValidationInfo.eventCustomerValidationTypeId ==
          EventCustomerValidationType.DB
        ) {
          this.eventCustomerValidationDetail = this.custValidationInfo.dbNumber;
        } else if (
          this.custValidationInfo.eventCustomerValidationTypeId ==
          EventCustomerValidationType.SubscriptionId
        ) {
          this.eventCustomerValidationDetail =
            this.custValidationInfo.subscriptionId;
        }
      });
  }

  onNextClick() {
    this.selectedPoeFilter =
      this.poeFilterOptions.find(
        f => f.value == EventCustomerValidationStatus.Pending
      ) || ({} as PoeStatusFilter);
    this.canShowCustomerPreviewModel = false;
    const eventId = this.eventIdList[++this.eventIndex];
    this.EventId = eventId;
    this.showCustomerValidationPreview(eventId);
  }

  onPreviousClick() {
    this.selectedPoeFilter =
      this.poeFilterOptions.find(
        f => f.value == EventCustomerValidationStatus.Pending
      ) || ({} as PoeStatusFilter);
    this.canShowCustomerPreviewModel = false;
    const eventId = this.eventIdList[--this.eventIndex];
    this.EventId = eventId;
    this.showCustomerValidationPreview(eventId);
  }

  checkForPrevious() {
    return !(this.eventIndex == 0);
  }
  checkForNext() {
    return !(this.eventIndex == this.eventIdList.length - 1);
  }

  onDeny() {
    this.updateEventCustomerValidation(EventCustomerValidationStatus.Rejected);
  }

  submitForApproval() {
    this.updateEventCustomerValidation(EventCustomerValidationStatus.Approved);
  }

  updateEventCustomerValidation(statusId) {
    this.isApproveReject = true;
    const eventRejection =
      this.formCustomerValidationRejection.controls['rejectionReason'].value;
    const additionNote =
      this.formCustomerValidationRejection.controls[
        'additionalNotesRejectionReason'
      ].value;
    const eventCustomerValidationRequestModel = {
      eventRegistrationId: this.EventId,
      customerValidationStatus: [
        {
          eventCustomerId: this.SelectedCustomer.eventCustomerId,
          eventCustomerValidationStatusId: statusId,
          additonalNote: additionNote,
          ...(statusId === EventCustomerValidationStatus.Rejected && {
            eventCustomerRejectionReasonId: eventRejection.eventCustomerRejectionReasonId
          })
        }
      ]
    };

    this.eventEdit
      .updateCustomerValidationStatuses(eventCustomerValidationRequestModel)
      .subscribe(
        () => {
          this.getCustomerValidiationInfo(
            eventCustomerValidationRequestModel.customerValidationStatus[0]
              .eventCustomerId
          );
          this.getCustomerDropDown(this.EventId);
          this.isApproveDeny = false;
          if (statusId == EventCustomerValidationStatus.Approved) {
            this.showMessage('Customer Validation Approved', false);
          } else {
            this.showMessage('Customer Validation Rejected', false);
          }
        },
        error => {
          this.showMessage(error.error.errorInfo, true);
        }
      );

    this.closeDeclineModal();
  }

  showMessage(message: string, isError?: boolean) {
    this.isApproveReject = false;
    this.msgsUsageDetails = [];
    this.msgsUsageDetails.push({
      severity: !isError ? 'success' : 'error',
      detail: message
    });
  }

  setFocus() {
    this.copiedValidationDetail = false;
    this.showToolTipCustomer = true;
  }
  setFocusout() {
    this.copiedValidationDetail = false;
    this.showToolTipCustomer = false;
  }

  copyText(textToCopy: string) {
    const copiedTextArea = document.createElement('textarea');
    const selectedId = document.activeElement?.id;
    copiedTextArea.value = textToCopy;
    document.body.appendChild(copiedTextArea);
    copiedTextArea.select();
    copiedTextArea.focus();
    document.execCommand('copy');
    document.body.removeChild(copiedTextArea);
    if (selectedId === 'eventCustomerValidationDetail') {
      this.copiedValidationDetail = true;
    }
    this.firstTime = new Date();
    this.setCopyFlag(selectedId);
  }
  setCopyFlag(arg: any) {
    if (new Date().getTime() < this.firstTime.getTime() + 1500) {
      setTimeout(() => {
        if (arg === 'eventCustomerValidationDetail') {
          this.copiedValidationDetail = false;
          this.showToolTipCustomer = false;
        }
      }, 1500);
    }
  }

  getProgramTypeGuid() {
    this.programTypeGuid =
      this.custValidationEventDetail.eventTypeId ==
      EventType.TeamsRoomsOneToMany
        ? ProgramTypesGUID.MRPP
        : ProgramTypesGUID.Events;
  }
}
